import request from '@/utils/request'
import { buildInventoryPriceStatusesUrl } from './endpoints'
import { toRepeatQuery } from './queryString'
import { BrandNameOption, GetBrandNameOptionsReq, GetGoodsCodeOptionsReq, GetInventoryPriceStatusesReq, GoodsCodeOption, InventoryPriceStatusItem } from './types'

export {
  INVENTORY_PRICE_STATUSES_URL,
  INVENTORY_PRICE_STATUSES_EXCEL_URL,
  buildInventoryPriceStatusesExcelUrl,
} from './endpoints'

/**
 * ST11(신규) 재고현황(단가) 화면의 보조 엔드포인트. 주 배선(조회/다운로드)은 endpoints.ts 참조.
 *
 * 보조 조회 2건은 서치헬퍼용이다(버튼 동작 아님) — ST10(LOGISPRD-10666)과 동일 배선:
 * - 상품코드 서치헬퍼 `GET /api/v1/master/products/goods-codes` — LOGISPRD-9955 (2.0)
 * - 브랜드명 서치헬퍼 `GET /api/v1/master/products/brand-names` — LOGISPRD-14184 (2.0, 1.0 grid/search BRD_NM 대체)
 */
export const GOODS_CODE_OPTIONS_URL = '/api/v1/master/products/goods-codes'
export const BRAND_NAME_OPTIONS_URL = '/api/v1/master/products/brand-names'

/**
 * ST11 재고현황(단가) 조회. (LOGISPRD-9596)
 *
 * 서버 페이징이 없어 조건에 걸린 전건이 한 번에 온다(1.0 동등) — 페이징·정렬·그룹핑은 그리드가 담당한다.
 * 필터가 모두 비면 BE 가 400 을 준다(OPR_INV 전건 스캔 방지) — 화면은 화주명 기본값(세션 화주)으로 이 경우에 도달하지 않는다.
 */
export const getInventoryPriceStatuses = (params: GetInventoryPriceStatusesReq) =>
  request.get<ApiResponseV2<{ items: InventoryPriceStatusItem[] }>>(buildInventoryPriceStatusesUrl(params))

/**
 * 상품코드 서치헬퍼 목록. (LOGISPRD-9955 — 1.0 `GDS_CD_SearchForm` 이관)
 *
 * 무페이징 distinct 목록이라 응답 전건이 모달 그리드에 실린다. 화주로 범위를 좁혀 조회한다.
 */
export const getGoodsCodeOptions = (params: GetGoodsCodeOptionsReq) =>
  request.get<ApiResponseV2<{ items: GoodsCodeOption[] }>>(`${GOODS_CODE_OPTIONS_URL}?${toRepeatQuery(params)}`)

/**
 * 브랜드명 서치헬퍼 목록. (LOGISPRD-14184 — 1.0 `BRD_NM_SearchForm` 대체, ST10 과 동일 배선)
 *
 * master_item distinct 브랜드명, 브랜드명 부분일치·오름차순, 최대 1,000행. 0건은 HTTP 200 + 빈 목록이다.
 */
export const getBrandNameOptions = (params: GetBrandNameOptionsReq) =>
  request.get<ApiResponseV2<{ items: BrandNameOption[] }>>(`${BRAND_NAME_OPTIONS_URL}?${toRepeatQuery(params)}`)
